import { render, staticRenderFns } from "./travel-insurance-home-page.vue?vue&type=template&id=6b616bd6&scoped=true"
import script from "./travel-insurance-home-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./travel-insurance-home-page.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./travel-insurance-home-page.vue?vue&type=style&index=0&id=6b616bd6&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b616bd6",
  null
  
)

export default component.exports